
import { HeartBeat, SoftwareUpdateStatusRequest, UpdateRequest } from '../Types/ServiceTypes';
import { VerifySetUpCodePayload, DeviceMetrics, IADPState, AppConfigExtended, DeviceMetricsPatch } from '../Types/AppStateTypes';
import { environment, getOnlineServices} from './index';
import { DiagnosticDataTransferReq, ValidationResponse } from '@npd-ng/adp-types';
const logPrefix = "[ADPClient][RequestUtil]"
//TODO convert the different requests into one request for post as there is alot of repettive code
const HEADER_ENAEP = {
  'Content-Type': 'application/json', 
  Authorization:  "Basic YXBwY29uZnVzZXI6QSQkYzBuZnVaYQ"
}
const PUT_HEADER = {
  'x-amz-acl': 'bucket-owner-full-control', 
  'Content-Type': 'application/json',  
}
 const PUT_HEADER_NCS = {
  'x-amz-acl': 'bucket-owner-full-control', 
  'Content-Type': 'application/octet-stream',  
}
const RequestService = {
postSoftwareUpdateInquiry : async (payload:UpdateRequest,url:string, cb: (arg: any,arg1?: boolean) => void) =>{

    try {
        RequestService.request(url,'post',HEADER_ENAEP,payload)
        .then(async (response:Response)=> {
          const data = await response.json()
          const responseData = {
            status:response.status,
            ...data
          }
          cb(responseData);
        })
        .catch(async(error:any)=> {
          //console.log(error);
          console.error(`[RequestService][software update][${JSON.stringify(error)}]`);
          if(error?.code){
            console.error(`[RequestService][software update][${JSON.stringify(error)}]`);
              const response = {
                status:error?.code,
                error: {message: error.message, stack: error.stack}
              }
              cb(response);
            }
            else if(error.status){
              const errorResponse = error as Response
              const data = await errorResponse.json()
              const response = {
                status:errorResponse?.status,
                ...data
              }
              cb(response);
            }
            else{
              console.error(`[RequestService][software update][${JSON.stringify(error)}]`);
              const response = {
                status:"NotAvailable",
                error: error
              }
              cb(response);
            }
        });
    }
    catch(e){
      console.error(`[RequestService][validate setup code error][${JSON.stringify(e)}]`);
        cb(e, true);
    }
    },     
postSoftwareUpdateStatus: async (payload: SoftwareUpdateStatusRequest, url: string)=>{
  const promise =  new Promise<any>((resolve, reject) => {
    try {
        RequestService.request(url,'post',HEADER_ENAEP,payload)
        .then(async function (response:Response) {
          const data = await response.json() 
          const returnValue = {
            status:response.status,
            ...data
          }
          resolve(returnValue);
        })
        .catch(async(error:any)=> {
          console.error(`[RequestService][postSoftwareUpdateStatus error][${JSON.stringify(error)}]`);
          if(error?.code){
            console.error(`[RequestService][postSoftwareUpdateStatus error]][${JSON.stringify(error)}]`);
              const response = {
                status:error?.code,
                error: {message: error.message, stack: error.stack}
              }
              reject(response);
            }
            else if(error.status){
              const errorResponse = error as Response
              const data = await errorResponse.json()
              const response = {
                status:errorResponse?.status,
                ...data
              }
              reject(response);
            }
            else{
              console.error(`[RequestService][postSoftwareUpdateStatus error][${JSON.stringify(error)}]`);
              const response = {
                status:"NotAvailable",
                error: error
              }
              reject(response);
            }
        });
    }
    catch(e){
      console.error(`[RequestService][postSoftwareUpdateStatus error][${JSON.stringify(e)}]`);
      reject(JSON.stringify(e));
    }  
  });
  return promise;
},
postCode : async (payload:VerifySetUpCodePayload,url:string, cb: (arg: any,arg1?: boolean) => void) =>{

  try {
      RequestService.request(url,'post',HEADER_ENAEP,payload)
      .then(async (response:Response)=>{
        const data = await response.json()
        const responseData = {
          status:response.status,
          ...data
        }
        cb(responseData);
      })
      .catch(async(error:any) =>{
        //console.log(error);
        console.error(`[RequestService][validate code error][${JSON.stringify(error)}]`);
          if(error?.code){
            console.error(`[RequestService][validate code error][${JSON.stringify(error)}]`);
              const response = {
                status:error?.code,
                error: {message: error.message, stack: error.stack}
              }
              cb(response);
            }
            else if(error.status){
              const errorResponse = error as Response
              const data = await errorResponse.json()
              const response = {
                status:errorResponse?.status,
                ...data
              }
              cb(response);
            }
            else{
              console.error(`[RequestService][validate code error][${JSON.stringify(error)}]`);
              const response = {
                status:"NotAvailable",
                error: error
              }
              cb(response);
            }
      });
  }
  catch(e){
    console.error(`[RequestService][validate setup code error][${JSON.stringify(e)}]`);
      cb(e, true);
  }
  },
  
postDeviceMetrics : async (payload:DeviceMetrics | DeviceMetricsPatch,url: string, patch: boolean) =>{
  const promise =  new Promise<any>((resolve) => {
  try {
      RequestService.request(url,patch ? 'PATCH' : 'post',HEADER_ENAEP,payload).then(async (response:Response)=>{
        const data = await response.json()
        const responseData = {
          status:response.status,
          ...data
        }
        resolve(responseData);
      })
      .catch(async(error:any) =>{
        //console.log(error);
        console.error(`[RequestService][DeviceMetrics][${JSON.stringify(error)}]`);
          if(error?.code){
            console.error(`[RequestService][DeviceMetrics][${JSON.stringify(error)}]`);
              const response = {
                status:error?.code,
                error: {message: error.message, stack: error.stack}
              }
              resolve(response)
            }
            else if(error.status){
              const errorResponse = error as Response
              const data = await errorResponse.json()
              const response = {
                status:errorResponse?.status,
                ...data
              }
              resolve(response)
            }
            else{
              console.error(`[RequestService][DeviceMetrics][${JSON.stringify(error)}]`);
              const response = {
                status:"NotAvailable",
                error: error
              }
              resolve(response)
            }
      });
  }
  catch(e){
    console.error(`[RequestService][postDeviceMetrics] error  ${e}`);
    resolve(false);
  }
})
return promise;
  },
postHeartbeat : async (payload:HeartBeat,url:string, cb?: (arg: any,arg1?: boolean) => void) =>{
  const HEADER_HB = {
    'Content-Type': 'text/plain', 
    Authorization:  "Basic YXBwY29uZnVzZXI6QSQkYzBuZnVaYQ"
  }
    try {
        
        RequestService.request(url,'post',HEADER_HB,payload)
        .then(async (response:Response)=>{
          const data = await response.json()
          const responseData = {
            status:response.status,
            ...data
          }
          if(cb)cb(responseData);
        })
        .catch(async(error:any) =>{
          //console.log(error);
          console.error(`[RequestService][post heartbeat error][${JSON.stringify(error)}]`);
            if(error?.code){
              console.error(`[RequestService][post heartbeat error][${JSON.stringify(error)}]`);
                const response = {
                  status:error?.code,
                  error: {message: error.message, stack: error.stack}
                }
                if(cb)cb(response);
              }
              else if(error.status){
                const errorResponse = error as Response
                const data = await errorResponse.json()
                const response = {
                  status:errorResponse?.status,
                  ...data
                }
                if(cb)cb(response);
              }
              else{
                console.error(`[RequestService][post heartbeat error][${JSON.stringify(error)}]`);
                const response = {
                  status:"NotAvailable",
                  error: error
                }
                if(cb)cb(response);
              }
        });
}
catch(e){
  console.error(`[RequestService][post heartbeat error][${JSON.stringify(e)}]`);
    if(cb)cb(e, true);
}
},
request : (url:string,method:string,headers?: any,payload?:any,timeout=15000 ): Promise<Response> =>{
        const requestConfig = {
          method: method,
          headers: headers,
          body: payload ? JSON.stringify(payload) : undefined,
          timeout:timeout
        };
        if(!payload){
          delete requestConfig.body
        }
        if(!headers){
          delete requestConfig.headers
        }
        return fetch(url,requestConfig)
},
constructDeviceValidationDataTransferPayload:(appState:IADPState,fileName?:string)=>{
  const payload: DiagnosticDataTransferReq = {
    deliveryType: "online", //TODO implement npn modeappState.sessionState.selectedAssessmentMode || "NotSelected" ,
    dataType:"DIAGNOSTIC",
    taskType: "UPLOAD",
    taskMessage: "Post validation logs",
    dataSubCategory: "device-validation",
    data: {
      fileName: fileName ||`${appState.appState.appLaunchId}.${appState.sessionState.selectedAssessmentMode}.device-validation.json`,
    },
    clientDetails: {
      ip: appState.sessionState.networkDetails?.address || "0.0.0.0",
      appName: `ng-enaep-student-app/${appState.deviceState.deviceType?.toLocaleLowerCase()}/p1`,
      deviceDetails: {
        deviceType: appState.deviceState.deviceType || "NPE"as any, 
        deviceName: appState.deviceState.deviceId || "NotAvailable",
      },
    },
  };
  const logHeader = {
    "schemaVersion": "1.0.1",
    "releaseVersion": appState.appState.releaseVersion,
    "buildNumber": appState.appState.releaseBuildNumber,
    "appVersion": appState.appState.appVersion,
    "appType": "npd-ng-student-app",
    "deviceDetails": {
      "deviceType": appState.deviceState.deviceType,
      "deviceName": appState.deviceState.deviceId,
      "deviceModel": appState.deviceState.deviceModel,
      "hostingPlatform": appState.appState.runtimePlatform
    },
    "sessionDetails": {
      "clientLaunchId":  appState.appState.appLaunchId,
      "adpLaunchDateTime":  appState.appState.appLaunchTime,
      "setupCode": appState.sessionState.schoolDetails?.setupCode,
      "participantId": "NotAvailable",
      "assessmentDeliveryMode": appState.sessionState.selectedAssessmentMode,
      "serverDetails": environment.resolveApiDomain(appState.appState.configuration)
    }
  }
  return {payload,logHeader};
},
/**
 * 
 * @param appState 
 * @param fileName 
 * @param data 
 * @returns Promise
 * If playload and logHeader undefined, construct the request from current app state values
 * Logs that stored from previous sessions shall come with predefined payload and logHeader
 */
postValidationLogs: (appState:IADPState,fileName:string,data: {payload:DiagnosticDataTransferReq,logHeader:any},responses?:ValidationResponse[])=> new Promise<boolean>((resolve)=>{
  const _getRequestPayload=()=>{
    
    if(responses){
      if(data.payload && data.logHeader && appState.deviceReadinessSummary){
        return {...data,deviceValidationChecks:{deviceName:appState?.deviceReadinessSummary?.deviceName, status:appState?.deviceReadinessSummary?.status,responses:responses}}
      }
      else{
        const {payload,logHeader} = RequestService.constructDeviceValidationDataTransferPayload(appState,fileName);
        return {
            payload:payload,
            logHeader:logHeader,
            deviceValidationChecks:{deviceName:appState?.deviceReadinessSummary?.deviceName, status:appState?.deviceReadinessSummary?.status,responses:responses}
          }
      }
    }
    else{
      if(data.payload && data.logHeader){
        return {...data,deviceValidationChecks:appState.deviceReadinessSummary}
      }
      else {
      const {payload,logHeader} = RequestService.constructDeviceValidationDataTransferPayload(appState,fileName);
      return {
          payload:payload,
          logHeader:logHeader,
          deviceValidationChecks:appState.deviceReadinessSummary
      }
      }
    }
  }
  const {deviceValidationChecks, logHeader,payload}  = _getRequestPayload();
  const getSignedUrl=(url:string, payload:DiagnosticDataTransferReq,cb: any)=>{
    RequestService.request(url,'post',HEADER_ENAEP,payload)
    .then(async(response: any) => {
      if(response.status === 200) {
        const data = await response.json()
        cb(data.dataUri)
      }
    }).catch((e:any) => {
      console.error(`[getSignedUrl not available: ${JSON.stringify(e)}`);
      cb(false)
    })
  }
  const onSignedUrl = async (response:any)=>{
    if(response){
        RequestService.request(response,'put',PUT_HEADER,{...logHeader,deviceValidationChecks:deviceValidationChecks})
        .then(()=>{
        resolve(true);
      }).catch((err:any)=>{
        console.error("An error occurred trying to send the device validation log.",err);
        resolve(false)
      })
    }
    else{
      resolve(false);
    }
  };
  const onlineServiceConfig = getOnlineServices(appState.appState.configuration);
  let url: string | undefined =`${environment.resolveApiDomain(appState.appState.configuration)}/${onlineServiceConfig?.dataTransfer.sign}`;
  if(url)getSignedUrl(url,payload,onSignedUrl);
}) 
  };
export default RequestService;